import { useEffect, useRef } from 'react';
import Typed from 'typed.js';

const Typewriter = ({ texts, speed }) => {
  /*const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let timeout;

    if (currentIndex <= text.length) {
      timeout = setTimeout(() => {
        setCurrentText(prevText => prevText + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, delay);

    } else if (infinite) { // ADD THIS CHECK
      setCurrentIndex(0);
      setCurrentText('');
    }

    return () => clearTimeout(timeout);
  }, [currentIndex, delay, infinite, text]);

  return <span>{currentText}</span>;*/

  // Create reference to store the DOM element containing the animation
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      //strings: ['<i>First</i> sentence.', '&amp; a second sentence.'],
      //typeSpeed: 50,
      strings: texts,
      typeSpeed: speed,
      loop: true,
      backDelay: 2000
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, [texts, speed]);

  return (
    <span ref={el} />
  );
};

export default Typewriter;